import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'account-confirmed',
  templateUrl: './account-confirmed.component.html',
  styleUrls: ['./account-confirmed.component.scss']
})
export class AccountConfirmedComponent implements OnInit {  
code:string;
  constructor(protected router: Router,public authService:AuthService,private activatedRoute: ActivatedRoute) { 
    
    this.activatedRoute.queryParams.subscribe(params => {
      this.code = params['oobCode'];
      console.log(this.code); // Print the parameter to the console. 
    });
  }
 
 
  ngOnInit(): void {

    this.authService.afAuth.applyActionCode(this.code).then(
      (result) =>{ console.log(result)})
    


  }
  sendTo(url:string):void{
    console.log(url)
    this.router.navigate([url]);
  }
}
